// Local-date helpers. Prevents UTC-vs-local timezone drift that made
// reports appear on the previous day for users in negative UTC offsets
// (e.g. Panama UTC-5).

// Returns today's date as YYYY-MM-DD in the browser's LOCAL timezone.
export const todayISO = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

// Parses a YYYY-MM-DD string as a LOCAL date (not UTC midnight).
// Accepts full ISO strings too; falls back to native Date parsing.
export const parseLocalDate = (value) => {
  if (!value) return new Date(NaN);
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  return new Date(value);
};
